//
// smooth-scroll.js
// Theme module
//

'use strict';

(function() {

    //
    // Variables
    //

    var toggle = '[data-toggle="smooth-scroll"]';

    //
    // Functions
    //

    function init(toggle) {
        var options = {
            clip: true,
            speed: 300,
            speedAsDuration: true,
            easing: 'easeInQuad',
            offset: function(anchor, toggle) {
                return toggle.dataset.offset ? toggle.dataset.offset : 60;
            }
        };

        // Init
        new SmoothScroll(toggle, options);
    }

    //
    // Events
    //

    if (typeof SmoothScroll !== 'undefined' && toggle) {
        init(toggle);
    } else {
        console.warn("SmoothScroll not initialized")
    }

})();
